import http from "@core/fetch";
import { ID } from "@datassential/platform-ui-lib";
import { useData } from "@hooks/useData";
import { SocialPosts, ISocialPosts } from "@models/SocialPosts";
import { components } from "@apiSchema";
import { useEffect, useMemo } from "react";

type AbortablePromise = Promise<any> & { abort?: () => void; };

function getSocialPostsFactory() {
    let promise: AbortablePromise | null = null;

    return async function getSocialPosts (
        wordId: ID,
        association: string,
        year: string | null = null,
        month: number | null = null,
    ): Promise<ISocialPosts> {
        if (promise && promise.abort) {
            promise.abort();
        }

        promise = http.getXHR(
            'get food profile social association',
            {
                keywordId: wordId,
                associationValue: association,
                year,
                month,
            },
        );

        const response: components["schemas"]["SocialKeywordWithAssociationPostsViewModel"] = await promise;

        if (response?.keywordPosts?.data) {
            try {
                return new SocialPosts({ apiModel: response.keywordPosts.data });
            } catch (err) {
                console.error(err);

                return new SocialPosts();
            }
        }

        return new SocialPosts();
    }
}

const idleFetchFn = async () => {
    return new SocialPosts();
}

export function useFoodSocialPosts(
    wordId: ID,
    association: string,
    year: string | null = null,
    month: number | null = null,
) {
    const realFetchFn = useMemo(
        () => getSocialPostsFactory(),
        [],
    );

    const isIdle = association === '' && year === null && month === null;

    const fetchFn = isIdle
        ? idleFetchFn
        : realFetchFn;

    useEffect(() => {}, [association, wordId]);

    return useData(new SocialPosts(), fetchFn, wordId, association, year, month);
}